(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/footer/footer.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/footer/footer.js');

'use strict';

const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const activeMethodAtom = svs.iam_idp.atoms.activeMethodAtom;
const loginMethods = svs.iam_idp.constants.loginMethods;
const _svs$iam_idp$componen = svs.iam_idp.components.footer,
  ToggleCustomer = _svs$iam_idp$componen.ToggleCustomer,
  GetApp = _svs$iam_idp$componen.GetApp;
const Footer = () => {
  const activeMethod = useAtomValue(activeMethodAtom);
  return React.createElement("footer", {
    className: "footer"
  }, activeMethod === loginMethods.freja && React.createElement(ToggleCustomer, null), React.createElement(GetApp, null));
};
svs.iam_idp.components.footer.Footer = Footer;

 })(window);